import React from 'react';

const SvgNumberTwo = (props: any) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20.5" cy="20.5" r="20" fill="#393939" />
    <path
      d="M18.4947 26.8147H16.9373L17.0867 26.6867C22.6333 21.9293 24.8733 19.3053 24.8733 16.66C24.8733 13.9933 22.8893 12.5 20.372 12.5C17.1933 12.5 15.8067 14.8253 15.2093 16.02L15.4867 16.148C16.596 14.2067 18.068 13.5453 19.476 13.5453C21.3533 13.5453 22.6333 14.8467 22.6333 16.9587C22.6333 19.6253 20.5853 22.5907 16.404 26.9213L15.1667 28.2013V28.2867H24.724L25.2787 26.388C23.1453 26.6867 21.268 26.8147 18.4947 26.8147Z"
      fill="#F4F2EF"
    />
  </svg>
);

export default SvgNumberTwo;
